export const paywallCurrencyCodes = {
  brl: "brl",
} as const;
